module.exports = __webpack_public_path__ + "img/CM6SF.3bce7cbc.png";